import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Event from "../../components/Event";
import Introduction from "../../components/Introduction";
import "./EventPage.css";
import DefaultPage from "../DefaultPage/DefaultPage";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import Loader from "../../components/Loader";

const EventPage = () => {
  //fetch stránky (uvod)
  const {
    loading: loadingIntroduction,
    error: errorIntroduction,
    data: dataIntroduction,
  } = useFetch(`${config.api}/api/events-page?populate=background`);

  //fetch udalosti
  const { loading, error, data } = useFetch(
    `${config.api}/api/events?sort[0]=from:asc`
  );

  // možné stavy při/po fetchi
  if (loadingIntroduction) return <Loader />;
  if (errorIntroduction)
    return <DefaultPage message="Chyba při načítání úvodu" />;
  if (!dataIntroduction || !dataIntroduction.data)
    return <DefaultPage message="Chyba při načítání úvodu" />;

  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání událostí" />;
  if (!data || !data.data) return <DefaultPage message="Žádné udalosti" />;

  //? test
  //? console.log("projekty", data);

  //změna titulku stránky v prohlížeči
  document.title = dataIntroduction.data.title;

  return (
    <div>
      <Navbar />
      <Introduction
        title={dataIntroduction.data.title}
        text={dataIntroduction.data.description}
        image={dataIntroduction.data.background.url}
      />
      <div className="container-fluid background-white">
        <div className="container container-background d-flex flex-wrap justify-content-center align-items-center">
          {data.data.map((event) => (
            <Event
              key={event.id}
              id={event.documentId}
              name={event.name}
              from={event.from}
              to={event.to}
              overview={event.overview}
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default EventPage;
